import { render } from './render';
var createNode = function (children, type) {
    var mountPoint = document.createElement('div');
    if (type === 'tooltip') {
        mountPoint.className = 'g2-tooltip';
    }
    render(children, mountPoint);
    return mountPoint;
};
export default createNode;
